<script>
import { mapGetters, mapActions } from 'vuex'

import ApiStore from '@/api/store'
import { JP } from '@/constants/regions'
import validate from '@/utils/validate'
import imgMail from './images/icon-mail@2x.png'

const HEADER_DEFAULT_BG_IMG = require('@/assets/img-cover-default.png')

function slugValidator (rule, value, callback) {
  if (!validate.slug(value)) {
    return callback(new Error(this.$t('Setting.Store.message.slug_error')))
  } else {
    callback()
  }
}

export default {
  name: 'BasicInfo',
  data () {
    return {
      JP,
      imgMail,
      oldSlug: null,
      form: {
        slug: '',
        name: '',
        contact_email: '',
        description: ''
      },
      isEditingStore: false,
      storeRules: {
        slug: [
          {
            required: true,
            message: this.$t('Setting.Store.message.buyer_path'),
            trigger: 'blur'
          },
          {
            required: true,
            min: 4,
            max: 24,
            message: this.$t('Setting.Store.message.slug_length'),
            trigger: 'blur'
          },
          { required: true, validator: slugValidator.bind(this), trigger: 'blur' }
        ],
        name: [
          {
            required: true,
            message: this.$t('Setting.Store.message.store_name'),
            trigger: 'blur'
          }
        ],
        contact_email: [
          {
            required: true,
            type: 'email',
            message: this.$t('Register.enter_email'),
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    ...mapGetters('Me', [
      'token',
      'storeName',
      'currentStore',
      'region',
      'currency',
      'imageUploadUrl'
    ]),

    isSlugEdited () {
      return this.currentStore.slug !== this.form.slug
    },

    setHeaderBGImagStyle () {
      const imgUrl = this.currentStore && this.currentStore.image_url
        ? this.currentStore.image_url
        : HEADER_DEFAULT_BG_IMG

      return {
        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 30%,rgba(0, 0, 0, 0.4) 100%), url(${imgUrl})`
      }
    },
    uploadHeaders () {
      return { Authorization: `Bearer ${this.token}` }
    },
    avatarUrl () {
      return this.currentStore && this.currentStore.avatar_url
        ? this.currentStore.avatar_url
        : require('@/assets/icon-default-user-lg.png')
    },
    buyerPath () {
      return this.$VUE_APP_BUYER_DOMAIN_NAME
    }
  },

  created () {
    this.setInitStore()
  },

  methods: {
    ...mapActions(['setLoading']),
    ...mapActions('Me', ['updateCurrentStore', 'fetchCurrentStore']),

    async handleUploadSuccess (response, file) {
      const apiStore = new ApiStore()
      await apiStore.update(this.storeName, { image_id: response.id })
      this.fetchCurrentStore()
    },
    async handleAvatarSuccess (response, file) {
      const apiStore = new ApiStore()
      await apiStore.update(this.storeName, { avatar_id: response.id })
      this.fetchCurrentStore()
    },

    handleBeforeUpload (file) {
      const fileMB = file.size / (1024 ** 2)

      if (fileMB > 2) {
        this.$message.error(this.$t('Setting.Store.message.upload_limit'))
        return false
      }

      return true
    },
    copyLink () {
      const copyUrl = this.buyerPath + '/' + this.form.slug
      this.copyText({
        url: copyUrl,
        success: this.$t('Setting.Store.message.copy_link', { copyUrl }),
        error: this.$t('Setting.Store.message.copy_fail')
      })
    },

    setInitStore () {
      const {
        name,
        slug,
        description
      } = this.currentStore
      const contactEmail = _.get(this.currentStore, 'store_registrant.contact_email')

      this.oldSlug = slug

      this.form = {
        name,
        slug,
        description,
        contact_email: contactEmail
      }
    },
    cancelUpdateStore () {
      // 取消更新，還原 store 資料
      this.isEditingStore = false
      this.setInitStore()
    },
    async validateForm () {
      try {
        await this.$refs.storeForm.validate()
        return true
      } catch (e) {
        this.$message.error(this.$t('Setting.Store.message.form_incomplete'))
        return false
      }
    },

    updateStore () {
      const apiStore = new ApiStore()

      const data = {
        ...this.form
      }

      if (!this.isSlugEdited) {
        delete data.slug
      }

      return apiStore.update(this.storeName, data)
    },

    async handleSubmit () {
      this.setLoading(true)

      // 表單驗證 && 更新 Store
      if (!(await this.validateForm() && await this.updateStore())) {
        this.setLoading(false)
        return
      }

      // 判斷有無更改 slug，更新 CurrentStore 紀錄
      if (this.currentStore.slug !== this.form.slug) {
        await this.updateCurrentStore(this.form.slug)
        this.$router.push(`/${this.form.slug}/Setting`)
      }

      // 刷新 Vuex Store 資料
      await this.fetchCurrentStore()

      this.isEditingStore = false

      this.$message({
        showClose: true,
        duration: 1000,
        message: this.$t('Setting.Store.message.save_success'),
        type: 'success'
      })

      this.setLoading(false)
    }
  }
}
</script>

<template lang="pug" src="./BasicInfo.pug"></template>
<style lang="scss" src="./BasicInfo.scss" scoped></style>
